import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Configure axios base URL
import axios from 'axios';
axios.defaults.baseURL = 'https://scpbc.org';

const app = createApp(App);
app.use(router);
app.mount('#app');

